import ReplayRoundedIcon from '@mui/icons-material/ReplayRounded';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useAccessInfo } from '../contexts/AccessTokenProvider';
import { Securables } from '../Enums';

interface CompletedOnboardingReplayMenuItemProps {
    onNavigate?: () => void;
}

const CompletedOnboardingReplayMenuItem = ({ onNavigate = () => { } }: CompletedOnboardingReplayMenuItemProps) => {
    const history = useHistory();
    const { hasOneOfRoles } = useAccessInfo();
    const canReplay = hasOneOfRoles([
        Securables.organization_administrator,
        Securables.synergist_admin,
    ], true);

    if (!canReplay)
        return null;

    const handleReplay = () => {
        onNavigate();
        history.push('/OnboardingReplay/onboarding-ready');
    };

    return <MenuItem onClick={handleReplay} dense>
        <ListItemIcon><ReplayRoundedIcon /></ListItemIcon>
        <ListItemText>Replay completed onboarding</ListItemText>
    </MenuItem>;
};

export default CompletedOnboardingReplayMenuItem;
